import { StackNavigationProp, createStackNavigator } from "@react-navigation/stack";
import React from "react";

import OrderEvaluation from "@/screens/Order/OrderEvaluation";
import OrderList from "@/screens/Order/OrderList";
import OrderTraking from "@/screens/Order/OrderTracking";

export type OrderStackParamList = {
  orderList: undefined;
  orderTracking: {
    orderId: string;
  };
  orderEvaluation: {
    orderId: string;
  };
};

export const OrderRoutePaths = {
  orderList: "pedidos",
  orderTracking: "pedido",
  orderEvaluation: "avaliacao",
};

export type OrderNavigation = StackNavigationProp<OrderStackParamList>;

const OrderStackNav = createStackNavigator<OrderStackParamList>();

export const OrderStack = () => {
  return (
    <OrderStackNav.Navigator
      initialRouteName="orderList"
      screenOptions={{ headerShown: false, headerMode: "screen" }}>
      <OrderStackNav.Screen name="orderList" component={OrderList} options={{ title: "Pedidos" }} />
      <OrderStackNav.Screen
        name="orderTracking"
        component={OrderTraking}
        options={{ title: "Pedido" }}
      />
      <OrderStackNav.Screen
        name="orderEvaluation"
        component={OrderEvaluation}
        options={{ title: "Avaliação" }}
      />
    </OrderStackNav.Navigator>
  );
};
